module.exports = __webpack_public_path__ + "static/media/biothings-explorer-text-2.b43f58bf.svg";